import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { ThemeProvider, Typography, Box } from "@mui/material";
import "lottie-react";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/typography.js";
import "../../../components/avatar-group/avatar-group.styles.js";
import "../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../components/date-pickers/date-picker/theme/index.js";
import "../../../components/dialog/dialog.js";
import "../../../components/icons/all/all.js";
import "../../../components/label/label.styles.js";
import { MenuItem } from "../../../components/menu-item/menu-item.js";
import "../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import { createTheme } from "../../../constants/create-theme/create-theme.js";
import "../../../components/snackbar/snackbar.styles.js";
import "../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../components/translations/utils.js";
import "../../../components/time-select/time-select.styles.js";
import "../../../components/time-interval-select/time-interval-select.styles.js";
import { palette } from "../../../constants/colors/palette.js";
import { MuiButton } from "../../../themes/button/button.js";
import { MuiCheckbox } from "../../../themes/checkbox/checkbox.js";
import { MuiDialog } from "../../../themes/dialog/dialog.js";
import "../../../themes/external-theme/external-theme.js";
import { MuiFilledInput } from "../../../themes/filled-input/filled-input.js";
import "color-alpha";
import { MuiIconButton } from "../../../themes/icon-button/icon-button.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import { MuiSwitch } from "../../../themes/switch/switch.js";
import { MuiTabs } from "../../../themes/tabs/tabs.js";
import { EmployeeSearchInput } from "./components/employee-search-input/employee-search-input.js";
import { ArrowIcon, DropdownButton, EmployeesIcon, SearchMenu, SearchDivider, RoleCount } from "./employee-select.styles.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../themes/date-calendar/date-calendar.js";
import "../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../themes/day-calendar/day-calendar.js";
import "../../../themes/form-helper-text/form-helper-text.js";
import "../../../themes/form-label/form-label.js";
import "../../../themes/month-calendar/month-calendar.js";
import "../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../themes/pickers-month/pickers-month.js";
import "../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../themes/pickers-year/pickers-year.js";
import "../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/popover/popover.js";
import "../../../themes/radio/radio.js";
import "../../../themes/tooltip/tooltip.js";
import "../../../components/dialog/dialog.constants.js";
import "../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../components/icons/MainIcon/MainIcon.js";
import "../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../components/icons/CardIcon/CardIcon.js";
import "../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../components/icons/EditIcon/EditIcon.js";
import "../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../components/icons/EventNote/EventNote.js";
import "../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../components/icons/ListIcon/ListIcon.js";
import "../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../components/icons/PinIcon/PinIcon.js";
import "../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../components/menu-item/menu-item.styles.js";
import "../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../components/snackbar/snackbar.types.js";
import "../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../components/text-field/text-field.styles.js";
import "../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
import "lodash/debounce.js";
import "./components/employee-search-input/employee-search-input.styles.js";
import "./assets/icons/Search.js";
import "./assets/icons/Arrow.js";
import "./assets/icons/Employees.js";
const theme = createTheme({
  palette,
  components: {
    MuiButton,
    MuiCheckbox,
    MuiSwitch,
    MuiTabs,
    MuiDialog,
    MuiFilledInput,
    MuiIconButton
  }
});
const EmployeeSelect = ({
  title,
  fullWidth = false,
  labels,
  width = 216,
  maxHeight = 400,
  Button,
  showDeactivatedEmployees,
  showWorkingEmployees,
  context
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    toggleAllByRole,
    isAllEmployeesByRoleSelected,
    isAllSelected,
    toggleAll,
    toggleEmployee,
    selectedEmployeesEntities,
    selectedEmployeeReferenceIds,
    searchedEmployeeString,
    employeesByRoles,
    filteredEmployees,
    setShowDeactivatedEmployees,
    showDeactivatedEmployees: isDeactivatedEmployeesActive,
    showWorkingEmployees: isShowWorkingEmployeesActive,
    setShowWorkingEmployees
  } = context;
  const handleMenuToggle = (event) => setAnchorEl((prevState) => prevState ? null : event.currentTarget);
  const handleDisabledEmployeesToggle = () => setShowDeactivatedEmployees((prevState) => !prevState);
  const handleWorkingEmployeesToggle = () => setShowWorkingEmployees((prevState) => !prevState);
  const handleClose = () => setAnchorEl(null);
  const handleToggleRole = (role) => () => {
    toggleAllByRole(role);
  };
  const handleToggleEmployee = (id) => () => {
    toggleEmployee(id);
  };
  const showRoles = !searchedEmployeeString.length;
  const showActiveEmployeesSwitch = !!setShowDeactivatedEmployees && showDeactivatedEmployees;
  const showWorkingEmployeesSwitch = !!setShowWorkingEmployees && showWorkingEmployees;
  return /* @__PURE__ */ jsxs(ThemeProvider, { theme, children: [
    Button ? /* @__PURE__ */ jsx(Button, { onClick: handleMenuToggle, endIcon: /* @__PURE__ */ jsx(ArrowIcon, { isOpen: !!anchorEl }), fullWidth }) : /* @__PURE__ */ jsx(
      DropdownButton,
      {
        onClick: handleMenuToggle,
        isOpen: !!anchorEl,
        variant: "bordered",
        startIcon: /* @__PURE__ */ jsx(EmployeesIcon, {}),
        endIcon: /* @__PURE__ */ jsx(ArrowIcon, { isOpen: !!anchorEl }),
        size: "sm",
        fullWidth,
        children: /* @__PURE__ */ jsx(Typography, { variant: "Lato Overline Bold", align: "center", children: title })
      }
    ),
    /* @__PURE__ */ jsxs(
      SearchMenu,
      {
        open: !!anchorEl,
        anchorEl,
        onClose: handleClose,
        disableScrollLock: true,
        keepMounted: true,
        maxHeight,
        width,
        anchorOrigin: {
          horizontal: "left",
          vertical: "bottom"
        },
        children: [
          /* @__PURE__ */ jsx(EmployeeSearchInput, { labels: labels.search, context }),
          showRoles && !!filteredEmployees.length && /* @__PURE__ */ jsx(MenuItem, { variant: "switch", selected: isAllSelected, onClick: toggleAll, size: "s", children: labels.toggleAll }),
          showRoles && Object.keys(employeesByRoles).map((role) => /* @__PURE__ */ jsx(
            MenuItem,
            {
              onClick: handleToggleRole(role),
              variant: "switch",
              selected: isAllEmployeesByRoleSelected(role),
              size: "s",
              children: labels.roles.categories[role.toUpperCase()]
            },
            role
          )),
          showWorkingEmployeesSwitch && /* @__PURE__ */ jsx(
            MenuItem,
            {
              onClick: handleWorkingEmployeesToggle,
              variant: "switch",
              selected: isShowWorkingEmployeesActive,
              size: "s",
              children: labels.toggleWorkingEmployees
            }
          ),
          showActiveEmployeesSwitch && /* @__PURE__ */ jsx(
            MenuItem,
            {
              onClick: handleDisabledEmployeesToggle,
              variant: "switch",
              selected: isDeactivatedEmployeesActive,
              size: "s",
              children: labels.toggleDeactivatedEmployees
            }
          ),
          !filteredEmployees.length && /* @__PURE__ */ jsx(Typography, { variant: "Lato Emphasized 2", align: "center", marginBottom: 2, children: labels.none }),
          Object.entries(employeesByRoles).map(([role, employees]) => {
            const total = employees.length;
            const selected = filteredEmployees.filter(
              ({ positions, referenceId }) => selectedEmployeeReferenceIds.some((id) => referenceId === id) && positions.some(({ role: employeeRole }) => employeeRole === role)
            ).length;
            return /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx(SearchDivider, {}),
              /* @__PURE__ */ jsx(Box, { m: 2, children: /* @__PURE__ */ jsxs(Typography, { variant: "Lato Emphasized 1", children: [
                labels.roles.categories[role.toUpperCase()],
                /* @__PURE__ */ jsx(RoleCount, { variant: "Lato Emphasized 2", children: `(${selected}/${total})` })
              ] }) }),
              employees.map((employee) => /* @__PURE__ */ jsx(
                MenuItem,
                {
                  avatar: employee,
                  variant: "checkbox",
                  onClick: handleToggleEmployee(employee.referenceId),
                  selected: !!selectedEmployeesEntities[employee.referenceId],
                  children: employee.displayName
                },
                `${employee.referenceId}-${role}`
              ))
            ] }, role);
          })
        ]
      }
    )
  ] });
};
export {
  EmployeeSelect
};
